import type { Testimonial } from '../testimonials'

/**
 * Tekin Gülşen's words, from the closing card of
 * digitopia.co/customers/bridgestone/ — the three-part capture sent on
 * 2026-08-29 with *"tıpatıp tastamam şekilde hazırla"*.
 *
 * The card the Bridgestone story page closes on: `CURATED` in
 * `content/testimonials.ts` had no Bridgestone quote, which is why the Hall of
 * Fame's fourth position is held by Brisa. That note is another author's and
 * stands; whether this card should take the slot instead is a decision for
 * whoever wrote it, and nothing here changes the order on its own.
 *
 * A second quote by the same person: the Yazaki card carries his Digital
 * Maturity Index statement from that engagement, under his Yazaki title. Both
 * are as their own reference pages give them.
 */
export const added: Testimonial = {
  company: 'Bridgestone',
  logo: { name: 'Bridgestone', src: '/logo/bridgestonecard.png' },
  portrait: {
    src: '/photo/portrait-tekin-gulsen.png',
    alt: 'Tekin Gülşen, smiling, arms folded, in a dark suit and patterned tie.',
  },
  quote: [
    'I strongly recommend Digitopia to companies who want to thrive in the Digital Era. The '
    + 'professional attitude, multi-industry experience, and the comprehensive Digital Maturity '
    + 'Index tool which generates tangible and actionable recommendations for digital '
    + 'transformation, are quite special.',
  ],
  attribution: 'Tekin Gülşen, CIO/IT Director, BriSA',
  story: 'bridgestone',
}
